import { setMode } from "@stencil/core";
import * as globalConstants from "../constants/global-constants";
// import * as Sentry from "@sentry/react";
// import { UIKIT_VERSION, BRAND_NAME } from "../constants/global-constants";
export default function () {
  setMode((elm) => {
    return (elm as any).mode || elm.getAttribute("variant") || "default";
  });

  // Sentry.init({
  //   dsn: "https://604dd2a9ae6d5efea7bdd290b5ec44db@sentry.eon.com/158",
  //   release: UIKIT_VERSION,
  //   environment: BRAND_NAME,
  //   initialScope: {
  //     tags: {
  //       "uikit.version": UIKIT_VERSION,
  //       "uikit.brand": BRAND_NAME,
  //       "uikit.domain": window.location.host
  //     }
  //   },
  //   integrations: [new Sentry.BrowserTracing() /*, new Sentry.Replay()*/],
  //   // Performance Monitoring
  //   tracesSampleRate: 0.5 // Capture 100% of the transactions, reduce in production!
  //   // Session Replay
  //   // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  //   // replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // });

  /**
   * If fonts.preload is defined in theme json it will iterate through these definitions and add them to the head of the page.
   * That allows to preload the fonts and by that reduce layout shifts and enhance component width calculation.
   */
  if (globalConstants["PRELOAD_FONTS"]?.length) {
    globalConstants["PRELOAD_FONTS"].forEach((font: any) => {
      document.head.insertAdjacentHTML(
        "beforeend",
        `<link rel="preload" href="${font.src}" as="font" type="${font.type}" crossorigin="anonymous"/>`
      );
    });
  }
}
